import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Row, Col, Typography, Grid, Layout, Space, Button } from 'antd';
import './Category.css';
import { CategoryService, WPCategory } from '../../services/api.services';
import pic1 from '../../assets/images/pic-1.webp';

const categoryBannerImage = pic1;

const { Title } = Typography;
const { useBreakpoint } = Grid;
const CategoryPage: React.FC = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // URL State
  const queryParam = searchParams.get('q') || '';

  // Local State
  const [categories, setCategories] = useState<Array<WPCategory & { img?: string }>>([]);
  const [loading, setLoading] = useState(true);

  // Fetch Categories once on mount
  useEffect(() => {
    setLoading(true);
    CategoryService.getAll().then(catRes => {
      // Only show categories that have an image uploaded from the backend (optional, or just show all)
      const enrichedCats = catRes.data.filter((c: any) => c.img);
      setCategories(enrichedCats);
      setLoading(false);
    }).catch(err => {
      console.error('Failed to fetch categories', err);
      setLoading(false);
    });
  }, []);

  return (
    <main className="blog-page">
      {/* 1. HERO BANNER */}
      <section 
        className="blog-hero" 
        style={{ backgroundImage: `url("${categoryBannerImage}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <div className="blog-hero-overlay" />
        <div className="blog-hero-content">
          <p className="blog-hero-label">EXPLORE BY</p>
          <h1 className="blog-hero-heading">
            Browse recipes by your favorite category type.
          </h1>
          <p className="blog-hero-signature">Loganayaki Thamilselvan</p>
        </div>
      </section>

      {/* 2. MAIN LAYOUT (2 Columns) */}
      <div className="category-page-container">
        {/* Left Column: Category Cards */}
        <div className="recipes-column">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px 0' }}>
              <div style={{ display: 'inline-block', width: 44, height: 44, border: '3px solid #eee', borderTop: '3px solid #306046', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
          ) : categories.length > 0 ? (
            <Row gutter={[isMobile ? 0 : 32, 48]}>
              {categories.filter(cat => {
                const name = cat.name.toLowerCase();
                const slug = cat.slug.toLowerCase();
                return name !== 'uncategorized' && name !== 'author page' && name !== 'author pages' && slug !== 'loganayaki-pages';
              }).map((cat, index) => (
                <Col xs={24} sm={12} md={8} lg={8} key={cat.id}>
                  <div
                    onClick={() => navigate(`/recipe?category=${cat.slug}`)}
                    className="category-card-hover"
                    style={{
                      width: '100%',
                      aspectRatio: '4/5',
                      position: 'relative',
                      cursor: 'pointer',
                      overflow: 'hidden',
                      borderRadius: '8px',
                      marginBottom: '20px'
                    }}
                  >
                    <img 
                      src={cat.img || ''} 
                      alt={cat.name} 
                      style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s ease' }} 
                    />
                    <div style={{ 
                      position: 'absolute', 
                      inset: 0, 
                      background: 'rgba(0,0,0,0.45)', 
                      display: 'flex', 
                      flexDirection: 'column', 
                      justifyContent: 'center', 
                      alignItems: 'center',
                      transition: 'background 0.3s ease'
                    }}>
                      <h3 style={{ color: '#fff', margin: 0, fontFamily: 'Playfair Display, serif', fontSize: '24px', letterSpacing: '1px', textAlign: 'center', padding: '0 10px' }}>
                        {cat.name}
                      </h3>
                      {cat.count !== undefined && (
                        <span style={{ color: '#eee', fontSize: '12px', marginTop: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                          {cat.count} Recipes
                        </span>
                      )}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          ) : (
            <div style={{ textAlign: 'center', padding: '100px 0' }}>
              <Title level={3} style={{ color: '#888' }}>No categories found.</Title>
            </div>
          )}
        </div>


      </div>
    </main>
  );
};

export default CategoryPage;
